import {Component, Input, Renderer2, ViewChild, inject} from '@angular/core';
import {environment} from 'src/environments/environment';
import {RxAuthService} from 'src/app/services/rx-auth/rx-auth.service';
import {HttpClient} from '@angular/common/http';
import {RetailerProfileComponent} from 'src/app/profiles/retailer-profile/retailer-profile.component';
import {ListProfileComponent} from 'src/app/profiles/list-profile/list-profile.component';
import {ChartsCommonFunctions} from '../chartsCommonFunctions';
import {ActivatedRoute} from '@angular/router';
import * as Plotly from 'plotly.js-dist-min'
import {ElementRef} from '@angular/core';
import {ChartWrapperComponent} from '../chart-wrapper/chart-wrapper.component';
import {ChartHeaderComponent} from '../chart-header/chart-header.component';
import {DashboardService} from 'src/app/services/dashboard/dashboard.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {traceTheme} from '../chartTheme';
import {cloneDeep} from 'lodash';
import {Subscription} from "rxjs";
import {SettingsService} from "../../../../services/settings/settings.service";

@Component({
  selector: 'app-compared-bar-chart',
  templateUrl: './compared-bar-chart.component.html',
  styleUrls: ['./compared-bar-chart.component.scss'],
    standalone: true,
    imports: [
    ChartHeaderComponent,
  ]
})
export class ComparedBarChartComponent {
   @Input() rcl: any = '';
    @Input() model: any = '';
    @Input() chartId: string = '';
    @Input() retailer: any = null;
    @Input() isEditMode: boolean = false;
    @ViewChild('chartContainer', {static: false}) chartContainer!: ElementRef;
    showchart: boolean = false;
    profile: any = '';
    current_list: any = '';
    hasThumbnail: boolean = false;
    plotlyChart: any = null;
    originalChart: any = null;
    text_elements: any = '';
    plotId: string = '';
    isCompared: boolean = false;
    currentComparedWith: any = null;
  
  
    constructor(private auth: RxAuthService,
                private http: HttpClient,
                private retailerprofile: RetailerProfileComponent,
                private listprofile: ListProfileComponent,
                private common: ChartsCommonFunctions,
                private route: ActivatedRoute,
                private elementRef: ElementRef,
                private renderer: Renderer2,
                private chartWrapper: ChartWrapperComponent,
                private snackBar: MatSnackBar,
    ) {
    }
  
    private dashboardService: DashboardService = inject(DashboardService)
  
  
    chartData: any = {
    data: [ {
        y: ['Germany', 'Spain', 'UK','Italy','Other'], // x-axis data for first trace
        x: [1, 3, 2, 3, 4], // y-axis data for first trace
        type: 'bar', // plot type (line chart)
        mode: 'lines', // line and marker mode
        orientation: 'h',
        marker: {color: '#3792BF'},
     
        name: 'Amazon'
      },
       {
        y: ['Germany', 'Spain', 'UK','Italy','Other'], // x-axis data for first trace
        x: [5, 8, 2,4,3], // y-axis data for first trace
        type: 'bar', // plot type (line chart)
        mode: 'lines', // line and marker mode
        orientation: 'h',
        marker: {color: '#AACCFF'},
     
        name: 'Apple'
      },
       {
        y: ['Germany', 'Spain', 'UK','Italy','Other'], // x-axis data for first trace
        x: [2, 3, 5,2,7], // y-axis data for first trace
        type: 'bar', // plot type (line chart)
        mode: 'lines', // line and marker mode
        orientation: 'h',
        marker: {color: '#7D7979'},
     
        name: 'Ikea'
      },
        {
        y: ['Germany', 'Spain', 'UK','Italy','Other'], // x-axis data for first trace
        x: [3, 1, 3,3,1], // y-axis data for first trace
        type: 'bar', // plot type (line chart)
        mode: 'lines', // line and marker mode
        orientation: 'h',
        marker: {color: '#787c95'},
     
        name: 'Mango'
      },
      /*
        {
        y: ['Germany', 'Spain', 'UK','Italy','Other'], // x-axis data for first trace
        x: [1, 3, 2,5,8], // y-axis data for first trace
        type: 'bar', // plot type (line chart)
        mode: 'lines', // line and marker mode
        orientation: 'h',
        marker: {color: '#BDBDBD'},
     
        name: 'Zara'
      },
       {
        y: ['Germany', 'Spain', 'UK','Italy','Other'], // x-axis data for first trace
        x: [1, 1, 1,3,5], // y-axis data for first trace
        type: 'bar', // plot type (line chart)
        mode: 'lines', // line and marker mode
        orientation: 'h',
        marker: {color: '#0CAD99'},
     
        name: 'Tesco'
      },
      */
      {
        y: ['Germany', 'Spain', 'UK','Italy','Other'], // x-axis data for first trace
        x: [3, 5, 4, 3, 2], // y-axis data for first trace
        type: 'scatter', // plot type (line chart)
        mode: 'markers', // line and marker mode
        orientation: 'h',
       marker: {
    color: '#1B3E78',
    size: 15,
    symbol: 'cross' 
    },
      name: 'Multi-sector'
      },
         {
        y: ['Germany', 'Spain', 'UK','Italy','Other'], // x-axis data for first trace
        x: [2, 2, 1, 3, 3], // y-axis data for first trace
        type: 'scatter', // plot type (line chart)
        mode: 'markers', // line and marker mode
        orientation: 'h',
       marker: {
    color: '#1B3E78',
    size: 15,
    symbol: 'circle' 
  },
      name: 'UK500'
      },
    
    ],
      layout: {
        legend: {orientation: 'h', y: 1.2, bgcolor: 'rgba(0,0,0,0)'},
        //legend: { orientation: 'v',  bgcolor:'rgba(0,0,0,0)' },
        barmode:"group",
        bargroupgap:0.3,
        xaxis: {
          type: 'number',
           range: [0, null],
          showgrid: false,
          //title: 'X-axis', // x-axis label
        },
        yaxis: {
          showticksuffix: 'all',
          ticksuffix: '',
          tickformat: ".0f",
          showgrid: false,
          //title: 'Y-axis' // y-axis label
        },
        barcornerradius: 5,
  
        margin: {r: 15, l: 100, t: 30, b: 35},
        height: 300,
        autosize: true,
  
  
      },
      config: {
        displayModeBar: false,
        staticPlot: this.common.isMobile()
  
      },
  
    };
  
  async ngOnInit() {
      
  
  
     /* this.plotId = `#plot${this.chartId}`
      this.common.isIframe(this.elementRef, this.renderer)
      let currentPath = this.route.snapshot.url[0].path
      if (currentPath === 'shared' || currentPath === 'saved-charts') {
  
        let url = `${environment.backend_base}main/visualizations/get_public_chart_metadata/`
        let payload = {'rcl': this.rcl}
  
        await this.http.post(url, payload).subscribe((response: any) => {
          this.profile = response.profile
          this.current_list = response.profile.current_list
          this.get_profit_data(this.rcl)
        })
      } else if (!this.retailer) {
  
        this.profile = this.listprofile
        this.current_list = this.profile.listProfile.current_list
        await this.get_profit_data(this.rcl)
  
      } else if (currentPath !== 'shared' && currentPath !== 'saved-charts') {
  
        this.profile = this.retailerprofile.retailerProfile
        this.current_list = this.profile.current_list
        await this.get_profit_data(this.rcl)
      }
  
      //Check if "compared" exists in the parameters. Trigger the comparisson automatically if so.
      let compared = this.route.snapshot.queryParamMap.get('compare')
      if (compared) {
        this.addTrace()
        this.currentComparedWith = compared
      }
  
      //TODO: Improve this way of triggering the compare. Should be unified under a single subscription, potentially in a service
      this.retailerprofile.compareTo.subscribe((retailer: any) => {
  
        this.addTrace()
        //this.currentComparedWith = retailer.id
      })
  
      this.dashboardService.compareTo.subscribe((retailer: any) => {
        this.addTrace()
      })
  
      this.listprofile.compareTo.subscribe((retailer: any) => {
  
        this.addTrace()
      })
  
  */
  
    }
    ngAfterViewInit() {
      console.log(this.chartData)
  
      this.showchart = true
      this.plotId = '#plot'+this.chartId
      
      this.plotlyChart = this.chartContainer.nativeElement.querySelector(this.plotId)
  
      
      Plotly.newPlot(this.plotlyChart, this.chartData.data, this.chartData.layout, this.chartData.config)
      
    }
  
    get_profit_data(rcl: number | null) {
      let url = `${environment.backend_base}main/visualizations/get_visualization_data/`;
      let payload = {
        visualization: this.model,
        rcl: rcl,
        component: this.route.component!.name
      };
  
      let options = this.auth.httpOptions;
  
      this.http
        .post(url, payload, this.auth.httpOptions)
        .subscribe((response: any) => {
  
          this.hasThumbnail = response.data[0].fields.thumbnail !== null
          //this.hasThumbnail.next(response.data[0].fields.thumbnail !== null)
  
          let prov_data = response.data[0].fields.json.map(
            (item: any, index: number) => {
              if (item.type === 'scatter') {
                return {
                  ...item,
  
                  connectgaps: true,
                  textposition: 'none',
                  hovertemplate: '%{x}, %{text}',
                  line: {color: traceTheme[index], width: 3}
                  //type: 'scatter',
                  //mode: 'lines',
                  //line: { width: 3, color: traceTheme[index % traceTheme.length] },
                };
              } else if (item.type === 'bar') {
                return {
                  ...item,
  
                  connectgaps: true,
                  textposition: 'none',
                  hovertemplate: '%{x}, %{text}',
                  marker: {color: traceTheme[index], width: 3}
                  //type: 'scatter',
                  //mode: 'lines',
                  //line: { width: 3, color: traceTheme[index % traceTheme.length] },
                };
              }
            }
          );
          this.chartData.data = prov_data;
          let suffix = this.chartData.data[0].text[0].replace('.', '')
          suffix = suffix.replace(/[0-9]/g, '')
          this.chartData.layout.yaxis.ticksuffix = suffix
  
          this.text_elements = this.common.getTextElements(response.text_elements, this.profile)
          // console.log(this.profile)
          if (this.text_elements.subheader === '') { //TODO add showlegend=true if profile is sector or cluster alone
            this.text_elements.subheader = this.chartData.data[0].name
  
          }
  
  
          this.plotlyChart = this.chartContainer.nativeElement.querySelector(this.plotId)
          Plotly.newPlot(this.plotlyChart, this.chartData.data, this.chartData.layout, this.chartData.config)
  
          this.common.subscribeToUserEvents(this.plotlyChart, this.chartWrapper)
          this.originalChart = this.common.removeCircularReferences(this.plotlyChart);
          this.showchart = true;
        });
    }
  
    resizeChart(width: number, height: number, plotId: any) {
      this.chartId = plotId;
      this.plotId = `#plot${this.chartId}`
      this.plotlyChart = this.elementRef.nativeElement.querySelector(this.plotId)
  
      Plotly.relayout(this.plotlyChart, {'width': width, 'height': height})
  
    }
  
    checkIfThumbnail() {
      return this.hasThumbnail
    }
  
    addTrace() {
      if (this.chartWrapper.enableCompare) {
        let plotlyChart = this.elementRef.nativeElement.querySelector(this.plotId)
        if (this.isCompared) {
          //Get all traces except 0 and delete them
          let tracesToDelete = Array.from({length: plotlyChart.data.length}, (_, i) => i).filter(i => i !== 0);
          Plotly.deleteTraces(plotlyChart, tracesToDelete);
          //this.isCompared = false
        }
  
        let url = `${environment.backend_base}main/visualizations/get_visualization_compare_data/`
        let new_rcl = this.route.snapshot.queryParamMap.get('compare')
  
        let payload = {
          visualization: this.model,
          rcl: new_rcl,
          component: this.route.component!.name
        };
        this.http.post(url, payload).subscribe((response: any) => {
  
  
          for (let [index, newTrace] of response.data.entries()) {
            // console.log(newTrace)
            newTrace = newTrace.fields.json[0]
            newTrace.type = 'line'
            newTrace.line = {color: traceTheme[index+1], width: 3}
            newTrace['textposition'] = 'none',
            newTrace['hovertemplate'] = '%{x}, %{text}'
  
            this.waitForPlotlyData(plotlyChart, () => {
  
              Plotly.addTraces(plotlyChart, newTrace)
              this.isCompared = true
          })
  
  
          let hasRetailer = response.rcl_objects.find((obj:any) => obj.type === "retailer");
          let hasList = response.rcl_objects.find((obj:any) => obj.type === "list");
          let hasSector = response.rcl_objects.find((obj:any) => obj.type === "sector");
          let hasCluster = response.rcl_objects.find((obj:any) => obj.type === "cluster");
  
  
          let retailerIds = response.rcl_objects.filter((obj:any) => obj.type === "retailer").map((obj:any) => obj.id);
          let listIds = response.rcl_objects.filter((obj:any) => obj.type === 'list').map((obj:any) => obj.id)
  
          let matchingRetailers = response.data.filter(
            (item: any) => retailerIds.includes(item.fields.rcl)
          ).map((item:any)=> item.fields.json[0].name);
  
          let matchingLists = response.data.filter(
            (item: any) => listIds.includes(item.fields.rcl)
          ).map((item:any)=> item.fields.json[0].name);
  
          let mainTraceName = plotlyChart.data[0].name
  
  
          let subheader = ''
  
          let joiner = ', '
          if (matchingRetailers.length === 0){
            joiner = ''
          }
          else if (matchingRetailers.length === 1) {
            joiner = ' and '
          }
          if (hasList) {
            subheader = mainTraceName+ joiner + this.stringFormattedList(matchingRetailers) + ' compared to the ' + matchingLists.join(', ')
          } else
           {
            let list_name = this.current_list ? this.current_list.name : "Global1000"
            if (hasSector || hasCluster) {
              subheader = mainTraceName+ joiner + this.stringFormattedList(matchingRetailers) + ' compared to ' + list_name + ' retailers'
            } else {
              subheader = mainTraceName+ joiner + this.stringFormattedList(matchingRetailers) + ' compared'
              if (this.profile.current_list && this.profile.current_list.region.code !== 'ALL') {
                let region_name = this.profile.current_list.region.name
                if (region_name === 'UK') {
                      region_name = 'the UK'
                    }
                subheader = subheader + ' in ' + region_name
              }
            }
  
          //this.text_elements.subheader =  names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] + ' compared';
          }
          this.text_elements.subheader = subheader
        }
  
  
        })
  
      }
    }
  
    stringFormattedList(iterable:any) { //Creates a comma separated string with "and" between the last two elements
      if (iterable.length < 1) {
        return ''
      } else if (iterable.length === 1) {
        return iterable[0]
      } else{
        return iterable.slice(0,-1).join(', ') + (iterable.length > 1 ? ' and ' : '') + iterable[iterable.length-1]
      }
  
    }
  
    waitForPlotlyData(chart: any, callback: any, interval = 100, maxRetries = 50) { //Wait for plotly to be ready before comparing
      let retries = 0;
  
      const checkData = () => {
        if (chart && Array.isArray(chart.data)) {
          callback();
        } else if (retries < maxRetries) {
          retries++;
          setTimeout(checkData, interval);
        } else {
          console.error("plotlyChart.data is still undefined or not an array after max retries.");
        }
      };
  
      checkData();
    }
  }
  
  